import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

export const blankPackage = () => ({
  customer_id: '', package_name: '', service_type: 'Broadband', speed: '', mrp: '',
  operator_share_percent: '', isp_share_percent: '', includes_tv: false, includes_ott: false,
  ott_platforms: '', tv_channels: '', minimum_guarantee: '',
});

const num = (v) => (v === '' || v === null || v === undefined ? null : parseFloat(v));

const F = ({ label, children }) => (
  <div className="space-y-1.5"><Label className="text-xs uppercase tracking-wide text-slate-500">{label}</Label>{children}</div>
);

export const PackageForm = ({ initial, lcos, onSubmit, saving, isEdit }) => {
  const [f, setF] = useState(initial);
  const set = (k, v) => setF(p => ({ ...p, [k]: v }));
  const submit = (forApproval) => (e) => {
    e.preventDefault();
    onSubmit({
      ...f, mrp: num(f.mrp), operator_share_percent: num(f.operator_share_percent),
      isp_share_percent: num(f.isp_share_percent), minimum_guarantee: num(f.minimum_guarantee),
      submit_for_approval: forApproval,
    });
  };
  return (
    <form onSubmit={submit(true)} className="space-y-4" data-testid="lco-package-form">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <F label="LCO *">
          <Select value={f.customer_id} onValueChange={v => set('customer_id', v)} disabled={isEdit}>
            <SelectTrigger data-testid="pkg-lco-select"><SelectValue placeholder="Select LCO" /></SelectTrigger>
            <SelectContent>{lcos.map(c => <SelectItem key={c.customer_id} value={c.customer_id}>{c.company_name} ({c.customer_code})</SelectItem>)}</SelectContent>
          </Select>
        </F>
        <F label="Package Name *"><Input data-testid="pkg-name" required value={f.package_name} onChange={e => set('package_name', e.target.value)} placeholder="e.g. Home 100 Mbps" /></F>
        <F label="Service Type *">
          <Select value={f.service_type} onValueChange={v => set('service_type', v)}>
            <SelectTrigger data-testid="pkg-service-type"><SelectValue /></SelectTrigger>
            <SelectContent>{['Broadband', 'Broadband + IPTV', 'Broadband + OTT', 'Combo'].map(s => <SelectItem key={s} value={s}>{s}</SelectItem>)}</SelectContent>
          </Select>
        </F>
        <F label="Speed"><Input data-testid="pkg-speed" value={f.speed || ''} onChange={e => set('speed', e.target.value)} placeholder="100 Mbps" /></F>
        <F label="MRP incl. GST (₹/month) *"><Input data-testid="pkg-mrp" type="number" min="0" required value={f.mrp ?? ''} onChange={e => set('mrp', e.target.value)} /></F>
        <F label="Minimum Guarantee (₹)"><Input data-testid="pkg-min-guarantee" type="number" min="0" value={f.minimum_guarantee ?? ''} onChange={e => set('minimum_guarantee', e.target.value)} /></F>
        <F label="LCO Share %"><Input data-testid="pkg-operator-share" type="number" min="0" max="100" value={f.operator_share_percent ?? ''} onChange={e => set('operator_share_percent', e.target.value)} /></F>
        <F label="ISP Share %"><Input data-testid="pkg-isp-share" type="number" min="0" max="100" value={f.isp_share_percent ?? ''} onChange={e => set('isp_share_percent', e.target.value)} /></F>
      </div>
      <div className="flex flex-wrap gap-6">
        <label className="flex items-center gap-2 text-sm"><Switch data-testid="pkg-includes-tv" checked={f.includes_tv} onCheckedChange={v => set('includes_tv', v)} />Includes TV</label>
        <label className="flex items-center gap-2 text-sm"><Switch data-testid="pkg-includes-ott" checked={f.includes_ott} onCheckedChange={v => set('includes_ott', v)} />Includes OTT</label>
      </div>
      {(f.includes_tv || f.includes_ott) && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {f.includes_tv && <F label="TV Channels"><Input data-testid="pkg-tv-channels" value={f.tv_channels || ''} onChange={e => set('tv_channels', e.target.value)} /></F>}
          {f.includes_ott && <F label="OTT Platforms"><Input data-testid="pkg-ott-platforms" value={f.ott_platforms || ''} onChange={e => set('ott_platforms', e.target.value)} /></F>}
        </div>
      )}
      <div className="flex justify-end gap-2 pt-2 border-t border-slate-100">
        <Button type="button" variant="outline" disabled={saving} onClick={submit(false)} data-testid="pkg-save-draft">Save as Draft</Button>
        <Button type="submit" disabled={saving} className="bg-slate-900 text-white hover:bg-slate-800" data-testid="pkg-submit-approval">{saving ? 'Saving...' : 'Submit for Approval'}</Button>
      </div>
    </form>
  );
};
